/* Black Friday magic — étincelles électriques, néon, flash d'ouverture.
   Même esprit que noel-magic.js / halloween-magic.js : un seul moteur canvas,
   respect du prefers-reduced-motion, aucune animation tant qu'une modale est ouverte. */
(function () {
  // La fenêtre de dates est décidée UNE seule fois, dans layout/theme.liquid (classe bf-on).
  // Sans cette classe (avant le début, après la fin), rien ne se lance.
  if (!document.documentElement.classList.contains('bf-on')) return;
  if (window.__bfMagic) return;
  window.__bfMagic = true;

  var cfg = window.BF_MAGIC || {};
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return; // comme Noël : tout se coupe sur "moins d'animations"

  var end = Date.parse(cfg.end) || 0;
  if (end && Date.now() >= end) return;

  var GOLD = ['#FFC93C', '#FFE08A', '#FFD66B'];
  var PINK = ['#FF4F87', '#FF8FB4'];
  var CYAN = ['#39E0FF', '#8CF0FF'];

  var canvas, ctx, W, H, DPR = Math.min(window.devicePixelRatio || 1, 2);
  var particles = [];
  var bolts = [];
  var running = false;
  var rafId = null;

  function overlayOpen() {
    var d = document.querySelector('.drawer.is-open, cart-drawer[aria-hidden="false"]');
    var qv = document.querySelector('[data-quick-view-dialog][open]');
    return !!(d || qv);
  }

  function maxP() {
    return (W < 750) ? 90 : 170;
  }

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.id = 'bf-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
  }

  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = W * DPR; canvas.height = H * DPR;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }

  function addSpark(x, y, opts) {
    opts = opts || {};
    if (particles.length >= maxP()) particles.shift();
    var a = Math.random() * Math.PI * 2;
    var sp = opts.speed || (1 + Math.random() * 2.4);
    particles.push({
      x: x, y: y,
      vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - (opts.lift || 0),
      r: (opts.r || (1.1 + Math.random() * 2.2)),
      c: opts.color || pick(GOLD),
      life: 0, max: opts.max || (40 + Math.random() * 40),
      g: opts.gravity != null ? opts.gravity : 0.02
    });
  }

  function burst(x, y, n, opts) {
    for (var i = 0; i < n; i++) addSpark(x, y, opts);
  }

  function addBolt(x1, y1, x2, y2, color) {
    var segs = 7, pts = [[x1, y1]];
    for (var i = 1; i < segs; i++) {
      var t = i / segs;
      var mx = x1 + (x2 - x1) * t + (Math.random() - 0.5) * 60;
      var my = y1 + (y2 - y1) * t + (Math.random() - 0.5) * 40;
      pts.push([mx, my]);
    }
    pts.push([x2, y2]);
    bolts.push({ pts: pts, life: 0, max: 14, c: color || pick(CYAN) });
  }

  function megaFlash() {
    ensureCanvas();
    var cx = W * 0.5;
    document.documentElement.classList.add('bf-flash');
    setTimeout(function () { document.documentElement.classList.remove('bf-flash'); }, 260);
    addBolt(cx - W * 0.4, -20, cx - W * 0.1, H * 0.6, pick(CYAN));
    addBolt(cx + W * 0.1, -30, cx + W * 0.35, H * 0.5, pick(PINK));
    setTimeout(function () {
      addBolt(cx - W * 0.2, H + 20, cx + W * 0.05, H * 0.4, pick(GOLD));
    }, 160);
    burst(cx, H * 0.35, 46, { lift: 1.5, max: 70, speed: 1 + Math.random() * 4 });
    wake();
  }

  function drawParticles() {
    ctx.clearRect(0, 0, W, H);
    for (var i = bolts.length - 1; i >= 0; i--) {
      var b = bolts[i];
      b.life++;
      var alpha = Math.max(0, 1 - b.life / b.max);
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.strokeStyle = b.c;
      ctx.shadowColor = b.c;
      ctx.shadowBlur = 18;
      ctx.lineWidth = 2.4;
      ctx.beginPath();
      ctx.moveTo(b.pts[0][0], b.pts[0][1]);
      for (var p = 1; p < b.pts.length; p++) ctx.lineTo(b.pts[p][0], b.pts[p][1]);
      ctx.stroke();
      ctx.restore();
      if (b.life >= b.max) bolts.splice(i, 1);
    }
    for (var j = particles.length - 1; j >= 0; j--) {
      var s = particles[j];
      s.life++;
      s.x += s.vx; s.y += s.vy; s.vy += s.g;
      var a2 = Math.max(0, 1 - s.life / s.max);
      ctx.save();
      ctx.globalAlpha = a2;
      ctx.fillStyle = s.c;
      ctx.shadowColor = s.c;
      ctx.shadowBlur = 8;
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
      if (s.life >= s.max || s.y > H + 20) particles.splice(j, 1);
    }
  }

  function frame() {
    if (end && Date.now() >= end) { stop(); return; }
    if (!overlayOpen()) drawParticles();
    if (particles.length || bolts.length) {
      rafId = requestAnimationFrame(frame);
    } else {
      running = false;
    }
  }

  function wake() {
    ensureCanvas();
    if (!running) { running = true; rafId = requestAnimationFrame(frame); }
  }

  function stop() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    if (canvas) { ctx.clearRect(0, 0, W, H); }
  }

  // Poussière d'étincelles sous la souris / le doigt
  if (cfg.cursor) {
    var lastMove = 0;
    document.addEventListener('pointermove', function (e) {
      var now = Date.now();
      if (now - lastMove < 55) return;
      lastMove = now;
      if (overlayOpen()) return;
      ensureCanvas();
      addSpark(e.clientX, e.clientY, { r: 0.9 + Math.random() * 1.4, max: 26, speed: 0.4 + Math.random() * 0.6, color: Math.random() < 0.7 ? pick(GOLD) : pick(PINK) });
      wake();
    }, { passive: true });
    document.addEventListener('pointerdown', function (e) {
      if (overlayOpen()) return;
      ensureCanvas();
      burst(e.clientX, e.clientY, 10, { max: 34 });
      wake();
    }, { passive: true });
  }

  // Explosion dorée à chaque ajout au panier
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    ensureCanvas();
    var btn = form.querySelector('[type="submit"]');
    var x = W / 2, y = H / 2;
    if (btn) { var r = btn.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    burst(x, y, 34, { lift: 1.2, max: 50 });
    addBolt(x - 40, y - 60, x + 40, y + 10, pick(CYAN));
    wake();
  }, true);

  function heroShow() {
    var hero = document.querySelector('.lagon-hero, [data-section-type="lagon-hero"], .hero');
    if (hero) hero.classList.add('bf-hero');
    var title = document.querySelector('.lagon-hero__title, .hero__title, h1');
    if (title) title.classList.add('bf-neon-text');
    megaFlash();
  }

  function bannerShow() {
    var banner = document.querySelector('.collection-hero, .collection-banner, [data-section-type="main-collection"] .collection__header, .main-collection__header');
    if (banner) banner.classList.add('bf-coll-banner');
    var title = banner ? banner.querySelector('h1, .collection-hero__title, .collection-banner__title') : document.querySelector('h1');
    if (title) title.classList.add('bf-neon-text');
    ensureCanvas();
    if (banner) {
      var r = banner.getBoundingClientRect();
      burst(r.left + r.width * 0.15, r.top + r.height * 0.3, 16, { max: 60 });
      burst(r.left + r.width * 0.85, r.top + r.height * 0.6, 16, { max: 60 });
    } else {
      burst(W * 0.5, 80, 16, { max: 60 });
    }
    wake();
  }

  function start() {
    if (cfg.page === 'index') heroShow();
    else if (cfg.page === 'collection') bannerShow();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(start, 50);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 50); });
  }
})();
